import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { ClipPath, Defs, G, Path, Rect } from "react-native-svg";

export const IconMarker: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconMarker"><G ClipPath="url(#clip0_9378_27005)"><Path d="M17.2496 1.5L3.59961 12L11.9996 20.4L22.4996 6.75L17.2496 1.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M4.5 13.5C4.5 13.5 3.5 17.5 1.5 19.35L4.65 22.5C6.5 20.4 10.5 19.5 10.5 19.5" stroke="currentColor" strokeLinecap="square"/></G><Defs><ClipPath id="clip0_9378_27005"><Rect width="24" height="24" fill="white"/></ClipPath></Defs></CentralIconBase>;
});

export default IconMarker;
